<template>
    <el-dialog
        :title="(isForm ? (modelId ? '编辑' : '添加设备型号') : '查看') + dialogTitle"
        :model-value="modelValue"
        width="640px"
        @close="closed"
        class="zy-addForm"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 560px">
            <el-form-item label="设备类型" prop="type">
                <el-select v-if="isForm" filterable v-model="formData.type" placeholder="请选择设备类型" style="width: 100%">
                    <el-option
                        v-for="item in equipTypeOptionLists"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <span v-else>{{ equipTypeOptionObj[formData.type] }}</span>
            </el-form-item>
            <el-form-item label="型号名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name" placeholder="请输入型号名称"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="型号编码" prop="code">
                <el-input v-if="isForm" v-model="formData.code" placeholder="请输入型号编码"></el-input>
                <span v-else>{{ formData.code }}</span>
            </el-form-item>
            <el-form-item label="通信类型" prop="comm_type" v-if="isSystemAdmin">
                <el-select v-if="isForm" v-model="formData.comm_type" placeholder="请选择通信类型" style="width: 100%">
                    <el-option
                        v-for="item in commTypeList"
                        :key="item.value"
                        :label="item.name"
                        :value="Number(item.value)"
                    ></el-option>
                </el-select>
                <span v-else>{{ commTypeObj[formData.comm_type] }}</span>
            </el-form-item>
            <el-form-item label="所属品牌" prop="brand">
                <el-select v-if="isForm" v-model="formData.brand" filterable placeholder="请选择所属品牌" style="width: 100%">
                    <el-option
                        v-for="item in brandOptionList"
                        :key="item.id"
                        :label="`${item.name} (${item.code})`"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <span v-else>{{ brandObj?.name }}</span>
            </el-form-item>
            <template v-if="typeCode === 'DAC'">
                <el-form-item label="制热高功率" prop="high_power">
                    <el-input v-if="isForm" v-model="formData.high_power" placeholder="请输入制热高功率"></el-input>
                    <span v-else>{{ formData.high_power }}</span>
                </el-form-item>
                <el-form-item label="制热中功率" prop="mid_power">
                    <el-input v-if="isForm" v-model="formData.mid_power" placeholder="请输入制热中功率"></el-input>
                    <span v-else>{{ formData.mid_power }}</span>
                </el-form-item>
                <el-form-item label="制热低功率" prop="low_power">
                    <el-input v-if="isForm" v-model="formData.low_power" placeholder="请输入制热低功率"></el-input>
                    <span v-else>{{ formData.low_power }}</span>
                </el-form-item>
            </template>
            <el-form-item label="产品图片" prop="albums">
                <div v-if="isForm" class="albums-upload-lists">
                    <el-upload
                        ref="albumsUploader"
                        class="uploader"
                        action="#"
                        list-type="picture-card"
                        :auto-upload="false"
                        :on-change="handleImageChange"
                        :on-remove="handleImageRemove"
                        :file-list="albumsEditLists"
                    >
                        <el-icon class="avatar-uploader-icon">
                            <plus />
                        </el-icon>
                        <template #tip>
                            <div class="el-upload__tip">请上传 jpg/png 类型的图片且文件大小不能超过 2Mb.</div>
                        </template>
                    </el-upload>
                </div>
                <div v-else class="albums-lists">
                    <el-image
                        class="img-item"
                        v-for="item in albumsLists"
                        :key="item"
                        :src="item"
                        fit="contain"
                        :preview-src-list="albumsLists"
                        :initial-index="1"
                    ></el-image>
                </div>
            </el-form-item>
            <el-form-item label="产品手册" prop="manual">
                <div v-if="isForm" class="files-upload-lists">
                    <el-upload
                        ref="manualUploader"
                        class="uploader"
                        action="#"
                        :limit="1"
                        :auto-upload="false"
                        :on-exceed="handleFileExceed"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :file-list="filesEditLists"
                    >
                        <el-button type="primary" :icon="UploadFilled">请选择文件...</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                请上传 doc/docx/xls/xlsx/ppt/pptx/pdf/jpg/png 类型的文件且大小不能超过 5Mb.
                            </div>
                        </template>
                    </el-upload>
                </div>
                <div v-else>
                    <a v-if="formData.manual" :href="LOCALFS_ROOT + formData.manual" target="_blank">
                        <el-button type="primary" :icon="Download">查看</el-button>
                    </a>
                    <span v-else>-</span>
                </div>
            </el-form-item>
            <el-form-item label="显示排序" prop="list_order">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    class="mx-4"
                    :min="0"
                    :max="999999"
                    controls-position="right"
                />
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>
            <!-- <el-form-item label="设备型号状态" prop="status">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">启用</el-radio>
                    <el-radio :value="0">禁用</el-radio>
                </el-radio-group>
                <span v-else>{{ formData.status == 0 ? '禁用' : '启用' }}</span>
            </el-form-item> -->
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                <div v-else>{{ formData.remark }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { computed, defineEmits, defineProps, ref, toRaw, watch } from 'vue'
import { addEquipModel, getCommunicationType, getEquipModelDetail, putEquipModel } from '@/api/equipModel'
import { getBrandOption } from '@/api/deviceBrand/deviceBrand'
import { ElMessage } from 'element-plus'
import { Download, Plus, UploadFilled } from '@element-plus/icons'
import { LOCALFS_ROOT } from '@/constant'
import { getItem } from '@/utils/storage'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    typeId: {
        type: String,
        default: ''
    },
    typeCode: {
        type: String,
        default: ''
    },
    modelId: {
        type: String,
        required: false
    },
    equipTypeOptionLists: {
        type: Array,
        default: () => []
    }
})

// 是否为系统管理员
const isSystemAdmin = computed(() => getItem('userInfo')?.is_system_admin)

const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    id: '',
    name: '',
    code: '',
    type: '',
    comm_type: '',
    albums: [],
    manual: '',
    status: 1,
    remark: '',
    high_power: '',
    mid_power: '',
    low_power: ''
})
let postEditAlbums = []
let postUploadAlbums = []
let postManual = ''
// 设备编码非中文验证
const validatePass = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入设备类型标识'))
    } else if (!/^[^[\u4e00-\u9fa5]{1,50}]*$/.test(value)) {
        callback(new Error('设备类型标识不可含有中文'))
    } else {
        callback()
    }
}

// 设备品牌表单验证
const validateBrandPass = (rule, value, callback) => {
    if (formData.value.type === '64bf8f1dc67057c1956cd548' && value === undefined) {
        callback(new Error('请选择设备品牌'))
    } else {
        callback()
    }
}

// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '型号名称为必填项'
        }
    ],
    code: [
        {
            required: true,
            validator: validatePass,
            trigger: 'blur'
        }
    ],
    type: [
        {
            required: true,
            trigger: 'change',
            message: '请选择所属设备类型'
        }
    ],
    comm_type: [
        {
            required: true,
            trigger: 'change',
            message: '请选择通信类型'
        }
    ],
    brand: [
        {
            required: true,
            trigger: 'change',
            validator: validateBrandPass
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 通信类型
const commTypeList = ref([])
const commTypeObj = ref(null)
// 通道
const channelTypeList = ref([])
const channelTypeObj = ref(null)
const getCommunicationTypeFun = async () => {
    const { comm_type: commType, channel_type: channelType } = await getCommunicationType()
    commTypeObj.value = commType
    channelTypeObj.value = commType
    for (const item in commType) {
        commTypeList.value.push({
            value: item,
            name: commType[item]
        })
    }
    for (const item in channelType) {
        channelTypeList.value.push({
            value: item,
            name: channelType[item]
        })
    }
}

getCommunicationTypeFun()

// 品牌选项列表
const brandOptionList = ref()
const getBrandOptionList = async () => {
    brandOptionList.value = await getBrandOption()
}

getBrandOptionList()

// 构建类型显示对象
const equipTypeOptionObj = computed(() => {
    const optionObj = {}
    props.equipTypeOptionLists.forEach((item) => {
        optionObj[item.id] = item.name
    })
    return optionObj
})
// 构建品牌显示对象
const brandObj = ref()
const brandeOptionObj = async (id) => {
    brandObj.value = brandOptionList.value.find((item) => item.id === id)
}

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
    formData.value.remark = ''
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.modelId !== '') {
        await doPutEquipModel()
    } else {
        await doAddEquipModel()
    }
}

const getPostFormData = () => {
    const postFormData = new FormData()
    postFormData.append('id', formData.value.id || '')
    postFormData.append('name', formData.value.name || '')
    postFormData.append('code', formData.value.code || '')
    postFormData.append('type', formData.value.type || '')
    postFormData.append('is_cabinet', formData.value.is_cabinet || '')
    postFormData.append('cabinet_uint', formData.value.cabinet_uint || '')
    postFormData.append('manufacturer', formData.value.manufacturer || '')
    postFormData.append('brand', formData.value.brand || '')
    postFormData.append('list_order', formData.value.list_order || 0)
    postFormData.append('remark', formData.value.remark || '')
    postFormData.append('channel_type', formData.value.channel_type)
    if (props.typeCode === 'DAC') {
        postFormData.append('high_power', formData.value.high_power || '')
        postFormData.append('mid_power', formData.value.mid_power || '')
        postFormData.append('low_power', formData.value.low_power || '')
    }
    postFormData.append(
        'channel_inputs',
        formData.value.channel_type === 1 || formData.value.channel_type === 3 ? formData.value.channel_inputs : ''
    )
    postFormData.append(
        'channel_outputs',
        formData.value.channel_type === 2 || formData.value.channel_type === 3 ? formData.value.channel_outputs : 0
    )
    postFormData.append('comm_type', Number(formData.value.comm_type))
    if (postEditAlbums.length) {
        postEditAlbums.forEach((item) => {
            postFormData.append('albums', item)
        })
    }
    if (postUploadAlbums.length) {
        postUploadAlbums.forEach((item) => {
            postFormData.append('albums', item)
        })
    }
    postFormData.append('manual', postManual)
    return postFormData
}

// 修改
const doPutEquipModel = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        // await putEquipModel(formData.value)
        try {
            await putEquipModel(postFormData)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 添加
const doAddEquipModel = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        // await addEquipModel(formData.value)
        try {
            await addEquipModel(postFormData)
            // 模块添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 获取详情
const albumsLists = ref([])
const albumsEditLists = ref([])
const filesEditLists = ref([])
const doGetEquipModelDetail = async () => {
    const {
        id,
        name,
        code,
        type,
        albums,
        list_order,
        manual,
        remark,
        school,
        preset,
        comm_type: commType,
        brand,
        high_power,
        mid_power,
        low_power
    } = await getEquipModelDetail(props.modelId)
    formData.value = {
        id,
        name,
        code,
        type,
        albums,
        list_order,
        manual,
        remark,
        school,
        preset,
        status: 1,
        brand,
        comm_type: commType,
        high_power,
        mid_power,
        low_power
    }
    brandeOptionObj(brand)
    albumsLists.value = albums.map((item) => LOCALFS_ROOT + item)
    albumsEditLists.value = albums.map((item) => ({ name: item, url: LOCALFS_ROOT + item }))
    if (manual) {
        filesEditLists.value = [{ name: manual, url: LOCALFS_ROOT + manual }]
    }
    postEditAlbums = albums
    postManual = manual
    dialogTitle.value = name
}

const albumsUploader = ref()
// checkImageUpload()
const checkImageUpload = (file) => {
    const isJPG = file.type === 'image/jpeg'
    const isPNG = file.type === 'image/png'
    const isLt2M = file.size / 1024 / 1024 < 2

    if (!isJPG && !isPNG) {
        ElMessage.error('必须上传 jpg/png 格式的图片！')
        return false
    }
    if (!isLt2M) {
        ElMessage.error('图片文件不许超过 2MB!')
        return false
    }
    return true
}
// handleImageChange
const handleImageChange = (file, fileList) => {
    if (!checkImageUpload(file.raw)) {
        albumsUploader.value.handleRemove(file)
        return
    }
    postEditAlbums = []
    postUploadAlbums = []
    fileList.forEach((item) => {
        if (item.status === 'success') {
            postEditAlbums.push(item.name)
        } else if (item.status === 'ready') {
            postUploadAlbums.push(toRaw(item).raw)
        }
    })
    return false
}
// handleImageRemove
const handleImageRemove = (file, fileList) => {
    postEditAlbums = []
    postUploadAlbums = []
    fileList.forEach((item) => {
        if (item.status === 'success') {
            postEditAlbums.push(item.name)
        } else if (item.status === 'ready') {
            postUploadAlbums.push(toRaw(item).raw)
        }
    })
}

// checkFileUpload()
const checkFileUpload = (file) => {
    const suffixIndex = file.name.lastIndexOf('.')
    const suffix = file.name.substr(suffixIndex + 1).toLowerCase()
    const allowExt = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'jpg', 'png']
    const isEXT = allowExt.indexOf(suffix) >= 0
    const isLt2M = file.size / 1024 / 1024 < 5

    if (!isEXT) {
        ElMessage.error('必须上传 doc/docx/xls/xlsx/ppt/pptx/pdf/jpg/png 格式的文件！')
        return false
    }
    if (!isLt2M) {
        ElMessage.error('文件不许超过 5MB!')
        return false
    }
    return true
}
// handleFileChange
const handleFileChange = (file, fileList) => {
    if (!checkFileUpload(file.raw)) {
        manualUploader.value.handleRemove(file)
        return
    }
    postManual = file.raw
}
// handleFileRemove
const handleFileRemove = (file, fileList) => {
    postManual = ''
}

// 文件选择超出限制
const manualUploader = ref()
const handleFileExceed = (files) => {
    // manualUploader.value.clearFiles()
    // manualUploader.value.handleStart(files[0])
    ElMessage.warning('超限啦，只允许上传一个文件！')
}

// 只有modelId有的时候，才会去请求数据
watch(
    () => props.modelId,
    (newVal) => {
        if (newVal) {
            doGetEquipModelDetail()
        } else {
            // 置空
            formData.value = {
                id: '',
                name: '',
                code: '',
                type: '',
                manufacturer: '',
                albums: [],
                manual: '',
                remark: ''
            }
            albumsEditLists.value = []
            filesEditLists.value = []
            postEditAlbums = []
            postUploadAlbums = []
            postManual = ''
            dialogTitle.value = ''
        }
    }
)
watch(
    () => props.typeId,
    (newVal) => {
        formData.value.type = newVal
    }
)
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 36px;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
</style>
